export class EnumApiCompanyCert {
    constructor() {
        /**
         * @dec 获取授权码
         * @method post
         * @params
         */
        this.companyCert_getAuthorizeCode = {
            url: '/api/gateway/company-cert-bff/companyCert/file/getS3AuthorizeCode',
            method: 'get',
        };
        /**
         * @dec 上传视频/图片，有时效性
         * @method post
         * @params
         */
        this.companyCert_file_upload = {
            url: '/api/gateway/pcsd-bp-fos-entrance/tools/file/upload',
            method: 'post',
        };
        /**
         * @dec 上传视频/图片，无时效性
         * @method post
         * @params
         */
        this.companyCert_file_upload_share = {
            url: '/api/gateway/pcsd-bp-fos-entrance/tools/file/share/upload',
            method: 'post',
        };
        /**
         * @dec 上传视频/图片，无时效性,生产路径
         * @method post
         * @params
         */
        this.companyCert_file_upload_share_prod = {
            url: '/fos/tools/file/share/upload',
            method: 'post',
        };
        /**
         * @dec 查询文件路径 返回url
         */
        this.companyCert_file = {
            url: '/api/gateway/company-cert-bff/companyCert/file/findfileUrl',
            method: 'post',
        };
    }
}
